import React from "react";
import {Button, Form, Input, message, Modal, Select, Flex, Row, InputNumber } from "antd";
import { ScanOutlined } from '@ant-design/icons';
import NavItem from '../../components/nav-item';
import Can from '../../components/ability';
import SwitchShop from '../shop/switch-shop';
import Record from "./record";
import { getCurrentShopId } from "../shop/get-current-shop";
import { scanQRCode } from '../../utils/jsbridge';

const iconStyle = {
  fontSize: 28,
}

export default () => { 
    const [form] = Form.useForm();
    const [usedList, setUsedList] = React.useState([]);
    const [isOpen, setIsOpen] = React.useState(false);
    const [shopId, setShopId] = React.useState(null);
    
    React.useEffect(() => {
        const fetchShopId = async () => {
            const id = await getCurrentShopId();
            setShopId(id);
        };
        
        fetchShopId();
    }, []);
    
    React.useEffect(() => {
        if (shopId) {
            getVeriyRecord();
        }
    }, [shopId]);
    const submit = async () => {
        const values = await form.validateFields();
        values.shopId = await getCurrentShopId();
        console.log('Success:', values);

        await writeoff(values);
    };

    const writeoff = async ({id, shopId}) => {
        const response = await fetch('/api/writeoff', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id,
                shopId
            })
        });

        const result = await response.json();

        if(result?.success) {
            message.success('核销成功');
            getVeriyRecord();
        }else{
            message.error(result.data);
        }
    };

    // 唤起摄像头扫码
    const openScanModal = async () => { 
        try {
            const result = await scanQRCode();
            // 扫描成功，自动提交核销
            Modal.confirm({
                title: '核销码',
                content: result.data,
                okText: '核销',
                onOk() {
                    // 扫描成功，自动提交核销
                    submitWriteoff(result.data);
                }
            });
            // submitWriteoff(result.data);
        } catch (error) {
            console.error('Scan failed:', error);
            if (error.message !== 'User cancelled QR code scanning') {
                message.error(error.message || '扫码失败');
            }
        }
    };

    const submitWriteoff = async (id) => {
        if (!shopId) return;
        await writeoff({id, shopId});
    };

    const getVeriyRecord = async () => {
        if (!shopId) return;
        const response = await fetch(`/api/verify/used-list?shopId=${shopId}`);
        const res = await response.json();
        
        if(res?.success) {
            setUsedList(res?.data?.rows || []);
        }
    }

    return ( 
        <div>
            <SwitchShop />
            <Row gap={20} style={{ margin: '10px 0 0 0' }}>
                <Can action="read" subject="order">
                    <NavItem text="扫码核销" onClick={openScanModal}>
                        <ScanOutlined style={iconStyle} />
                    </NavItem>
                </Can>
            </Row>
            <h2>输码核销</h2>
            <Form form={form}>
                <Form.Item label="核销码" name="id" rules={[{ required: true, message: '请输入核销码' }]}> 
                    <InputNumber step={1} style={{ width: '100%'}} />
                </Form.Item>
                <Flex justify="center" gap={20}>
                    <Button href="/">取消</Button>
                    <Button type='primary' onClick={submit}>核销</Button>
                </Flex>
            </Form>
            <h2>核销记录</h2>
            <Record dataSource={usedList} />
        </div>
    );
};